jQuery(document).ready(function($) {
    // Initialize offset and page
    var offset = 0;
    let page = 1;

    function load_more_posts(e, totalPages) {
        
        if(page != 1){
            offset += parseInt(e);
        }

        $.ajax({
            
            method: 'POST',
            url: script_object.ajax_url,
            type: 'json', 
            data: {
                page: e <= 0 ? 0 : ++page,
                posts_per_page: e,
                offset: page === 1 ? offset : parseInt(offset) + parseInt(totalPages), 
                date: $('#select_date').val(),
                terms: $('#select_terms').val(),
                action: 'cards'
            },
            success: function (response) {
                $('.load_more_posts-cards').removeClass('active');

                if (response.indexOf('last_post_loaded_forum') > -1) {
                    $('.load_more_posts-cards').hide();
                }
                $(".tip-cards .row").append(response);
            },
        });
    }

    $('.load_more_posts-cards').on('click', function (e) {
        $(this).addClass('active');

        const numberOfPostsToShow = $('#load-more-posts').text();
        const totalPages = $('#max-number-post-per-page').text();
        
        load_more_posts(numberOfPostsToShow, totalPages);
    });
});